/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
//#endregion
//#region Images
//#endregion
//#region Services
import { requestGetStudentPenalties } from "services/settings/penaltyAdmin/dataAboutPenaltyAdmin";
//#endregion
//#region Utils
import { 
    INIT_FILTER_FIELDS, 
    TAB_KEYS_BY_VALUE, RECORDS_BY_PAGE, 
    DEFAULT_PARAMS_IN_FILL_PENALTIES } from "../constants";
import { getViewTabTitles } from "../helpers";
import useMainContext from "utils/context/useMainContext";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
//#endregion

const useStudentPenaltyList = ({
    filters, setTitleTabViews,
    currentTabIdx,
    notifications: {
        loadingRequest,
        toastMessage
    },
    paginator,
    setFatalError
}) => {
    const mainContext = useMainContext();
    //#region States
    const [studentPenaltyList, setStudentPenaltyList] = useState(null);
    const [triggerRequest, setTriggerRequest] = useState(true);
    const [searchedFilters, setSearchedFilters] = useState({ 
        ...INIT_FILTER_FIELDS,
        page: 0
    });
    const [idOfPenaltyToBeOpenedAfterAfterPerforingTheAction, setIdOfPenaltyToBeOpenedAfterAfterPerforingTheAction] = useState(0);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!triggerRequest) return;
        setTriggerRequest(false);
        fillPenaltyStudentList()
        .catch(() => {
            setFatalError(true);
            loadingRequest.hide();
            mainContext.setShowDialogUnexpectedError(true);
        });
    }, [triggerRequest]);
    //#endregion
    //#region Custom Hooks
    const dialogShowErrorWhenStudentIdIsLessThan5Characters = useShowDialogAlert();
    //#endregion
    //#region Functions
    const filtersControlsHaveBeenChanged = () => {
        const { studentId, penaltyStartDate } = filters.value;
        return Boolean(
            studentId !== searchedFilters.studentId ||
            penaltyStartDate !== searchedFilters.penaltyStartDate
        );
    }
    const fillPenaltyStudentList = async (params) => {
        const { messageForToast, penaltyId } = params || DEFAULT_PARAMS_IN_FILL_PENALTIES;
        if (checkIfExistsErrorBeforeRequest()) 
            return;
        // Realizando petición
        loadingRequest.show();
        const newPage = filtersControlsHaveBeenChanged() ? 1 : paginator.data.currentPage;
        const { tabs, penalties } = await requestGetStudentPenalties({
            ...filters.value,
            page: newPage,
            tab: currentTabIdx + 1
        });
        loadingRequest.hide();
        // Registrando filtros buscados
        setSearchedFilters({
            ...filters.value,
            page: newPage 
        });
        // Moviendo a nueva página
        paginator.movePage(newPage);
        // Setteando cantidad de páginas
        const currentTabKey = TAB_KEYS_BY_VALUE[currentTabIdx];
        paginator.setQuantityPages({
            quantityPages: Math.ceil(tabs[currentTabKey]/RECORDS_BY_PAGE),
            totalRecords: tabs[currentTabKey]
        });
        // Llenando cantidad total por tab
        setTitleTabViews(getViewTabTitles(tabs));
        // Setteando lista de servicios
        setStudentPenaltyList(penalties);
        setIdOfPenaltyToBeOpenedAfterAfterPerforingTheAction(penaltyId);
        showToastAfterFilledStudentPenaltyList(messageForToast);
    }
    const checkIfExistsErrorBeforeRequest = () => {
        const { studentId } = filters.value;
        if (studentId.length > 0 && studentId.length < 5) {
            dialogShowErrorWhenStudentIdIsLessThan5Characters.set(true);
            return true;
        }
        return false;
    }
    const showToastAfterFilledStudentPenaltyList = messageForToast => {
        // Mostrando toast si es necesario
        if (!messageForToast) return;
        toastMessage.show(messageForToast);
        toastMessage.hide();
    }
    const clearPenaltyList = () => {
        setStudentPenaltyList(null);
    }
    //#endregion
    return {
        studentPenaltyList: {
            setTriggerRequest,
            fill: fillPenaltyStudentList,
            clear: clearPenaltyList,
            value: studentPenaltyList
        }, 
        searchedFilters,
        dialogs: {
            dialogShowErrorWhenStudentIdIsLessThan5Characters
        },
        idOfPenaltyToBeOpenedAfterAfterPerforingTheAction: {
            value: idOfPenaltyToBeOpenedAfterAfterPerforingTheAction,
            set: setIdOfPenaltyToBeOpenedAfterAfterPerforingTheAction
        }
    };
}

export default useStudentPenaltyList;